import BaseService from '@/services/BaseService';

class NewsService extends BaseService {
    viewNews = (id) => this.get(`/view-news/${id}`);

    createNews = (data) => this.post('/create-news', data);

    getNewsList = (data) => this.post(`/get-news-list?page=${data.page}&per_page=${data.per_page}`, data || {});

    updateNews = (data, id) => this.post(`/edit-news/${id}`, data);

    changeNewsStatus = (data) => this.post('/update-news-status', data);

    generateNewsUrlWithToken = (data) => this.post('/generate-news-url-with-token', data);

    deleteNewsArticle = (id) => this.delete(`/delete-news-article/${id}`);
}

export default new NewsService();
